import {Injectable} from '@angular/core';
import {ApiUsersListPaginatedQueryParams} from './api-users-list-paginated-query-params';
import {Observable} from 'rxjs';
import {ApiUsersListResponse} from './api-users-list-response';
import {HttpClient, HttpParams} from '@angular/common/http';
import {RestApiService} from '../../../../core/services/http/rest-api.service';
import {ApiCreateUserResponse} from './api-create-user-response';
import {ApiCreateUserRequest} from './api-create-user-request';
import {AuthApiRoutesEnum} from '../../../../core/services/http/auth-api-routes.enum';
import {ApiUpdateUserRequest} from './api-update-user-request';
import {ApiUserResponse} from './api-user-response';

@Injectable()
export class UserRestApiService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _restApiService: RestApiService,
  ) {
  }

  public requestUsersListPaginated(queryParams: ApiUsersListPaginatedQueryParams): Observable<ApiUsersListResponse> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.USERS,
    ].join('/');
    const params: HttpParams = this._restApiService.createHttpParams(queryParams);
    return this._httpClient.get<ApiUsersListResponse>(url, {params: params});
  }

  public requestCreate(data: ApiCreateUserRequest): Observable<ApiCreateUserResponse> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.USERS,
    ].join('/');
    return this._httpClient.post<ApiCreateUserResponse>(url, data);
  }

  public requestUpdate(data: ApiUpdateUserRequest, userId: string): Observable<void> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.USERS,
      userId
    ].join('/');
    return this._httpClient.put<void>(url, data);
  }

  public requestEnable(userId: string, enabled: number): Observable<void> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.USERS,
      userId,
      AuthApiRoutesEnum.ENABLED,
      enabled
    ].join('/');
    return this._httpClient.put<void>(url, []);
  }

  public requestGetUser(userId: string): Observable<ApiUserResponse> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.USERS,
      userId
    ].join('/');
    return this._httpClient.get<ApiUserResponse>(url);
  }

  public requestDelete(userId: string): Observable<void> {
    const url: string = [
      this._restApiService.authApiUrl,
      AuthApiRoutesEnum.USERS,
      userId,
    ].join('/');
    return this._httpClient.delete<void>(url);
  }
}
